import { useEntitlementsActions, useAuth as useFronteggAuth, useTenantsState, useLoginWithRedirect, useLoginWithRedirectV2, } from "@frontegg/react";
import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FronteggConfigContext } from "../providers/AuthProvider";
const buildLogoutUrl = (config) => {
    const { baseUrl, postLogoutRedirectUri } = config;
    const postLogoutUrlVarName = "post_logout_redirect_uri";
    const logoutUrl = new URL(`${baseUrl}/oauth/logout`);
    logoutUrl.searchParams.set(postLogoutUrlVarName, postLogoutRedirectUri);
    return logoutUrl.toString();
};
const INTERNAL_ORGANIZATION_ID = "climatepartner-internal";
export function useAuth(isEmployeeLogin = false) {
    const fronteggAuthState = useFronteggAuth();
    const entitlementsActions = useEntitlementsActions();
    const { activeTenant } = useTenantsState();
    const combinedLogin = useLoginWithRedirect();
    const loginEmployee = useLoginWithRedirect();
    const loginCustomer = useLoginWithRedirectV2();
    const fronteggConfig = useContext(FronteggConfigContext);
    if (!fronteggConfig) {
        throw new Error("Frontegg config is missing");
    }
    useEffect(() => {
        if (fronteggConfig && !fronteggAuthState.isAuthenticated) {
            const currentPath = `${window.location.pathname}${window.location.search}`;
            /**
             * Frontegg's SDK redirects the user back to the root path after login. If we're doing
             * the same we're likely to break apps that want to redirect the user away from the
             * root path after login.
             */
            if (currentPath !== "/") {
                localStorage.setItem("_REDIRECT_AFTER_LOGIN_", currentPath);
            }
            if (fronteggConfig.isCombinedLogin) {
                combinedLogin();
                return;
            }
            if (isEmployeeLogin) {
                loginEmployee({ organization: INTERNAL_ORGANIZATION_ID });
            }
            else {
                loginCustomer({
                    additionalParams: undefined,
                    shouldRedirectToLogin: true,
                    firstTime: false,
                });
            }
        }
    }, [isEmployeeLogin, fronteggAuthState, loginEmployee, fronteggConfig, loginCustomer, combinedLogin]);
    const navigate = useNavigate();
    useEffect(() => {
        const originalRoute = localStorage.getItem("_REDIRECT_AFTER_LOGIN_");
        if (fronteggAuthState.isAuthenticated && originalRoute !== null) {
            localStorage.removeItem("_REDIRECT_AFTER_LOGIN_");
            navigate(originalRoute);
        }
    }, [fronteggAuthState.isAuthenticated, navigate]);
    const mapUser = (userFromFrontegg) => {
        const { id, name, email, tenantId, accessToken, metadata } = userFromFrontegg;
        const locale = JSON.parse(metadata)?.locale ?? null;
        return {
            id,
            name,
            email,
            organizationSlug: tenantId,
            accessToken,
            locale,
            isInternalUser: tenantId === INTERNAL_ORGANIZATION_ID,
        };
    };
    const hasPermission = (permissionKey) => entitlementsActions.isEntitledTo({ permissionKey }).isEntitled;
    const activeAccount = activeTenant
        ? { accountId: activeTenant.tenantId, accountName: activeTenant.name }
        : null;
    return {
        user: fronteggAuthState.user ? mapUser(fronteggAuthState.user) : null,
        isAuthenticated: fronteggAuthState.isAuthenticated,
        activeAccount,
        hasPermission,
        logout: (postLogoutRedirectUri) => {
            window.location.href = buildLogoutUrl({ baseUrl: fronteggConfig.baseUrl, postLogoutRedirectUri });
        },
    };
}
//# sourceMappingURL=useAuth.js.map